<!-- Specification image close button -->
@if (hideCarousel && isDialog) {
  <button id="imageCloseBtn" class="close-btn float-right" mat-dialog-close>
    <span class="crm-industrial-font icon-remove"></span>
  </button>
}

<!-- Carousel close button -->
@if (!hideCarousel && isDialog) {
  <button id="carouselCloseBtn" class="close-btn float-right" mat-dialog-close>
    <span class="crm-industrial-font icon-remove"></span>
  </button>
}

<div id="singleImageContainer" [ngClass]="{ 'single-image-view': isDialog && imgSources.length === 1 }">
  <!-- Specifications image/Opened carousel single image -->
  @if (hideCarousel || (imgSources.length < 2 && isDialog)) {
    <img id="specificationsImage" class="opened-image"
      [src]="imgSources[0]" />
  }
</div>

@if ((imgSources.length > 1 || (imgSources.length === 1 && !isDialog)) && !hideCarousel) {
  <ngx-hm-carousel id="imagesCarousel"
    [(ngModel)]="index"
    [infinite]="true" [data]="imgSources" [aniTime]="100" (ngModelChange)="imageChange($event)" class="carousel-container"
    [ngClass]="{ 'carousel-view': isDialog }">
    <section id="carouselSection" ngx-hm-carousel-container class="content">
      @for (img of imgSources; track img; let i = $index) {
        <img [id]="'carouselImage-'+i" class="carousel-image img" [src]="img"
          ngx-hm-carousel-item />
      }
      <ng-template #infiniteContainer></ng-template>
    </section>
    <ng-template #carouselContent let-img let-i="index">
      <img id="carouselDisplay" class="carousel-image img invisible" alt="">
    </ng-template>
    @if (imgSources.length > 1) {
      <ng-template #carouselPrev>
        <div id="prevArrowContainer" class="click-area">
          <span id="prevArrowIcon" class="crm-industrial-font icon-back material-icons"></span>
        </div>
      </ng-template>
    }
    @if (imgSources.length > 1) {
      <ng-template #carouselNext>
        <div id="nextArrowContainer" class="click-area icon-next">
          <span id="nextArrowIcon" class="crm-industrial-font icon-back material-icons"></span>
        </div>
      </ng-template>
    }
    @if (imgSources.length > 1; as model) {
      <ng-template #carouselDot let-model>
        <div id="imgPositionIcon" class="ball bg-accent" [ngClass]="{ 'ball-position': isDialog }"
        [class.visible]="model.index === model.currentIndex"></div>
      </ng-template>
    }
  </ngx-hm-carousel>
}